/**
 * Google Search Console HTML-tag token for the Too Good To Go account.
 * Www and business both emit this meta tag.
 */
export const googleSiteVerification = 'TJ1otkRVkHrThIDK9AucmH7U6xtucYp0mS75hjU6EeY';
